export default __webpack_public_path__ + "static/media/simple-icon.7c060652.svg";